export default __webpack_public_path__ + "27ae1f154fc180ee317e7f9002ac275a.png";